import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";

import { Button, CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";

import { openSnackbar } from "../../../Redux/Actions/snackbarActions";

import CustomerService from "../../../Service/Customer/customer.service";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import routeService from "Service/SalesRep/route.service";
import Loading from "Components/MUI_components/loading";

const AddCustomerFromPos = ({ setOpen }) => {
  const dispatch = useDispatch();
  const[loading,setLoading] = useState(false)
  
  const initValue = {
    companyName: "",
    customCode: "",
    title:"",
    firstName: "",
    secondName: "",
    phone1: "",
    phone2: "",
    email: "",
    website: "",
    creditLimit: 0,
    creditBalance: 0,
    creditDays: 0,
    isActive: true,
    isVerified: false,
    passportNumber: "",
    nicNumber: "",
    rating: 0,
    notes: "",
    fax: "",
    route: "",
    shipingCode: "",
    customerContacts: [],
    customerAddresses: [
      {
        firstName: "",
        email: "",
        secondName: "",
        phone1: "",
        phone2: "",
        address: "",
        country: "Sri Lanka",
        district: "",
        city: "",
        postBox: "",
        isActive: true,
      },
    ],
  };
  
  const[initialValues,setInitialValues] = useState(initValue)

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const Validation = yup.object({
    firstName: yup.string().required("Name is Required.."),
    // route: yup.object().required("Route is required"),
    nicNumber: yup.string().min(10).max(12),
    phone1: yup
      .string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Phone Number is Required.."),
      
  });

  useEffect(()=>{
    const fetchCustomers = async ()=>{
      setLoading(true)
      let customers = await CustomerService.getAll();
        let lastCustomCode = customers[customers.length -1].customCode;
        
        let newCustomCode = "C001"
        if(lastCustomCode) {
          let numericPart = lastCustomCode ? lastCustomCode.slice(-3) : 1;
          numericPart++;
          let prefixLegnth = lastCustomCode.length -3;
          let paddedSuffix = numericPart.toString().padStart(3, '0');
          let nonNumericPart = lastCustomCode.slice(0,prefixLegnth);
          newCustomCode =  nonNumericPart + paddedSuffix; 
        }
        setInitialValues({
          ...initialValues,
          customCode:newCustomCode
        })

        setLoading(false)

    }
    fetchCustomers();
  },[])

  const handleCustomerSubmit = async (values) => {
    try {
      await CustomerService.create(values);
      dispatch(openSnackbar(true, "success", `Customer created successfully`));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  return (
    <>
    {loading ?
     <Loading/> :(
      <Formik
      initialValues={initialValues} // Use initialValues instead of initValue
      validationSchema={Validation}
      onSubmit={async (values) => {
        await handleCustomerSubmit(values);
        setOpen(false);
      }}
          >
            {({ isSubmitting }) => (
              <Form autoComplete="off">
                <>
                  <div className="row">
                    <div className="col-2">
                      <FormControl control="input" name="customCode" label="Code" />
                    </div>
                    <div className="col-2">
                              <FormControl
                                control="input"
                                inputProps={{ list: "listTitle" }}
                                label="Title"
                                name="title"
                              />
                              <datalist id="listTitle">
                                <option>Mr.</option>
                                <option>Miss.</option>
                                <option>Mrs.</option>
                                <option>Ms.</option>
                                <option>Dr.</option>
                                <option>Prof.</option>
                                <option>Sir</option>
                              </datalist>
                  </div>
                    <div className="col-4">
                      <FormControl
                        control="input"
                        name="firstName"
                        label="First Name"
                      />
                    </div>
                    <div className="col-4">
                      <FormControl
                        control="input"
                        name="secondName"
                        label="Second Name"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4">
                      <FormControl control="input" name="phone1" label="Contact" />
                    </div>
                    <div className="col-4">
                      <FormControl
                        control="input"
                        name="nicNumber"
                        label="NIC Number"
                      />
                    </div>
                    <div className="col-4">
                      <FormControl
                        control="currency"
                        label="Credit Balance"
                        name="creditBalance"
                      />
                    </div>
                    {/* <div className="col-6">
                    <FormControl
                      control="asynchronousAutoComplete"
                      label="Route"
                      name="route"
                      variant="standard"
                      color="warning"
                      Service={routeService}
                      getOptionLabel={(option) =>
                        // option.code ? option.code : "" +
                        //   " - " +
                        option.name ? option.name : ""
                      }

                    />
                  </div> */}
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <FormControl control="input" name="notes" label="Note" />
                    </div>
                  </div>
                </>
                <div className="row flex-end mb">
                  <div style={{ display: "flex" }}>
                    <Button
                      disabled={isSubmitting}
                      startIcon={
                        isSubmitting && (
                          <CircularProgress color="inherit" size={20} />
                        )
                      }
                      variant="contained"
                      type="submit"
                      color="secondary"
                    >
                      save
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}
      
    </>
  );
};

export default AddCustomerFromPos;
